<template>
    <div v-if="zoom" class="modal-mask" v-show="show" transition="modal">
        <div class="modal-wrapper">
            <div class="modal-fabric-container">
                <button class="modal-close-button" @click="this.show = false">schließen</button>
                <div v-if="zoom.img" class="modal-image" v-bind:style="'background-image: url( '+ zoom.img +' )'"></div>
                <div class="modal-text">
                    <div class="modal-titlebox">
                        <div class="modal-title">{{ zoom.title }}</div>
                        <div v-if="zoom.composition" class="modal-subtitle">{{ translations[zoom.composition] }}</div>
                    </div>
                    <p>{{ zoom.infotext }}</p>
                    <div class="price" v-if="zoom.price > 0"> {{ zoom.price }} &euro;</div>
                    <div class="info-itembox">
                        <div class="info-item" v-if="zoom.weight > 0">
                            <div class="info-title">Gewicht</div>
                            <div class="info-icon">
                                <div class="darkbg"></div>
                                <div class="mask" v-bind:style="{ bottom: bottomWeight + '%' }"></div>
                                <img :src="globals.imgweight" alt=""/></div>
                            <span>{{ zoom.weight }} g</span>
                        </div>
                        <div class="info-item" v-if="zoom.yarn">
                            <div class="info-title">Garn</div>
                            <div class="info-icon garn"><img :src="globals.imggarn" alt=""/></div>
                            <span>{{ translations[zoom.yarn] }}</span>
                        </div>
                        <div class="info-item" v-if="zoom.weave">
                            <div class="info-title">Webart</div>
                            <div class="info-icon webart"><img :src="globals.imgweave" alt=""/></div>
                            <span>{{ translations[zoom.weave] }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
var jQuery = require('jquery')

export default {
  name: 'Zoom',
  props: [ 'zoom', 'show', 'globals', 'muster1', 'muster2', 'muster3', 'muster4' ],
  data: function () {
    var calcBottom = (100 + ((110 - parseInt(this.zoom.weight)) / 2)) * (-1)
    return {
      bottomWeight: calcBottom,
      translations: window.shirtdesigner.translations
    }
  },
  methods: {
    addSample: function (event) {
      /*global localStorage: false */
      var exists = false
      var message = ''
      var free = ''
      var keys = ['muster1', 'muster2', 'muster3', 'muster4']
      var i = 0
      var key
      while (keys[i]) {
        key = keys[i]
        if (localStorage.getItem(key)) {
          if (event.currentTarget.dataset.refnr === JSON.parse(localStorage.getItem(key))) {
            exists = key
            break
          }
        } else {
          if (!free) free = key
        }
        i++
      }
      if (!exists && free) {
        localStorage.setItem(free, JSON.stringify(event.currentTarget.dataset.refnr))
        this.$dispatch('setSwatch', {key: free, value: event.currentTarget.dataset.refnr})
        this.$dispatch('setMsg', {success: this.translations['Added to swatch box.']})
      } else {
        if (exists) {
          localStorage.removeItem(key)
          this.$dispatch('setSwatch', {key: key, value: ''})
          message = this.translations['Removed from swatch box.']
          this.$dispatch('setMsg', {success: message})
        } else {
          message = this.translations['You have already four fabrics in swatch box.']
          this.$dispatch('setMsg', {error: message})
        }
      }
    },
    bodyZoom: function () {
      if (this.show) {
        jQuery('body').css('overflow', 'hidden')
        jQuery('body').css('position', 'fixed')
        jQuery('body').css('left', 0)
        jQuery('body').css('right', 0)
      } else {
        jQuery('body').css('overflow', 'auto')
        jQuery('body').css('position', 'relative')
        jQuery('body').css('left', 'inherit')
        jQuery('body').css('right', 'inherit')
      }
    }
  },
  watch: {
    show: function () {
      this.bodyZoom()
    }
  },
  created: function () {
    this.bodyZoom()
  }
}

</script>


// WEBPACK FOOTER //
// Zoom.vue?0a99459a